<div class="modal-body">
    <a class="mt-1 float-right" (click)="hideNavModal()" title="Image"><i class="icon-close"></i></a>
    <form id="siteForm" appPromptUnsubmitted (ngSubmit)="save()">
        <div class="card-body">
            <ng-container *ngIf="isLandOwner; else partner">
                <h5 class="form-group col-sm-12">
                    Community owner
                </h5>
                <div class="form-group col-sm-12">
                    <label for="landOwner">Name</label>
                    <input class="form-control" name="landOwner" [appIsInvalid]="!site.landOwner"
                        [(ngModel)]="site.landOwner" id="landOwner" type="text" required>
                    <div class="invalid-feedback">
                        Name is Required.
                    </div>
                </div>

                <div class="form-group col-md-12">
                    <label for="name">Description</label>
                    <textarea class="form-control" [(ngModel)]="site.landOwnerDescription"
                        [appIsInvalid]="!site.landOwnerDescription" id="description" name="description" rows="3"
                        required></textarea>
                    <div class="invalid-feedback">
                        Description is Required.
                    </div>
                </div>

                <div class="form-group col-md-12">
                    <label for="name">Image</label>
                    <app-photo-upload [existingPhotoUrl]="site.landOwnerPhoto?.originalUrl"
                        (photoSelected)="onPhotoSelected($event)">
                    </app-photo-upload>
                </div>

            </ng-container>

            <ng-template #partner>
                <h5 class="form-group col-sm-12">
                    Planting partners
                </h5>
                <div class="form-group col-12">
                    <label for="partner">Name</label>
                    <div class="form-control custom-select multiselect" id="partner">
                        <ng-select [items]="_ngoPartners" name="ngoPartners" [addTag]="createNewPartner"
                            [searchFn]="trimAndLower" [loading]="creatingNew" [(ngModel)]="ngoPartner" multiple="false"
                            maxSelectedItems="1" bindLabel="partnerName" (change)="onSelect(ngoPartner)"
                            [appIsInvalid]="!ngoPartner">
                            >
                        </ng-select>
                    </div>
                    <div class="invaild-feedback-select" *ngIf="isInvildSelect">
                        Name is Required.
                    </div>
                </div>

                <div class="form-group col-md-12">
                    <label for="name">Description</label>
                    <textarea class="form-control" [(ngModel)]="description" [appIsInvalid]="!description"
                        id="description" name="description" rows="3" required></textarea>
                    <div class="invalid-feedback">
                        Description is Required.
                    </div>
                </div>

                <div class="form-group col-md-12">
                    <label for="name">Image</label>
                    <app-photo-upload [existingPhotoUrl]="photo?.originalUrl" (photoSelected)="onPhotoSelected($event)">
                    </app-photo-upload>
                </div>
            </ng-template>

            <div class="row  mt-5">
                <div class="col-md-12 text-center">
                    <button class="btn btn-primary mr-3">Save</button>
                    <button type="button" class="btn btn-outline-dark" (click)="hideNavModal()">Cancel</button>
                </div>

            </div>
        </div>
    </form>
</div>